import { Instagram, Facebook } from "lucide-react";

export const SOCIALS = {
  instagram: "https://instagram.com/arihantevent",
  facebook: "https://www.facebook.com/ArihantEventsHO/",
  google: "https://www.google.com/maps/search/?api=1&query=Arihant+Event+Management+Services+Indore",
};

export const GoogleIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.9 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 6.5 29.5 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z"/>
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 6.5 29.5 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>
    <path fill="#4CAF50" d="M24 44c5.2 0 10-2 13.6-5.2l-6.3-5.3C29.2 35 26.7 36 24 36c-5.3 0-9.7-3.1-11.3-7.9l-6.5 5C9.6 39.6 16.2 44 24 44z"/>
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.5l6.3 5.3C41.4 36.4 44 30.7 44 24c0-1.3-.1-2.3-.4-3.5z"/>
  </svg>
);

export const SocialLinks = ({ size = 16, className = "", itemClass = "", showGoogleBg = false }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <a href={SOCIALS.instagram} target="_blank" rel="noreferrer" data-testid="social-instagram" aria-label="Instagram" className={itemClass}>
      <Instagram size={size} />
    </a>
    <a href={SOCIALS.facebook} target="_blank" rel="noreferrer" data-testid="social-facebook" aria-label="Facebook" className={itemClass}>
      <Facebook size={size} />
    </a>
    <a href={SOCIALS.google} target="_blank" rel="noreferrer" data-testid="social-google" aria-label="Google" className={`${itemClass} ${showGoogleBg ? "bg-white rounded-full p-0.5 flex items-center justify-center" : ""}`}>
      <GoogleIcon size={size} />
    </a>
  </div>
);
